/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Connect_HintInputs */



/**
* | output |
* | --- |
* | "Allows members to join voice channels and hear others." |
*
* @param {Leveling_Perm_Connect_HintInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_connect_hint = /** @type {((inputs?: Leveling_Perm_Connect_HintInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Connect_HintInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Позволяет участникам заходить в голосовые каналы и слышать других.")
	return /** @type {LocalizedString} */ ("Allows members to join voice channels and hear others.")
});